<template>
  <div class="mb-3 form-check">
    <input
        type="radio"
        :name="id"
        :value="value"
        :checked="(modelValue === value)"
        @change="$emit('update:modelValue', value)"
        class="form-check-input"
        :id="id">
    <label class="form-check-label" :for="id">{{ name }}</label>
  </div>
</template>
<script setup>
import {defineProps} from 'vue'
defineProps({
  id: String,
  name: String,
  modelValue: String,
  value: String,
})
</script>
